<template>
  <div>
    <div v-if="this.confirmed == false" class="loader">Loading...</div>

    <div style="text-align: center" v-if="this.confirmed == true">
      <h1 >Your account has been confirmed</h1>

      <router-link :to="{ path: '/Login' }"> 
          Login
      </router-link>
    </div>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
export default {
  data(){
    return{
      confirmed: false,
    }
  },
  created() {

    EventService.ConfirmEmailFromRegistration(
      this.$route.query.userid,
      this.$route.query.token
    ).then(response =>{ 
        this.confirmed = true;
    })
    .catch(error => {
        console.log(error);

       this.$router.push({ name: "Login" });
    });
  }
};
</script>

<style scoped>

h1{
  text-align: center;
  color: rgb(102, 102, 102);
  padding: 90px;
}
</style>